import { selectProduct } from "@/store/slices/product";
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Tooltip from "./tooltip";
import styles from "../../../../styles/tooltip.module.scss";

const ProductDetailsDetailTab = () => {
  const productState = useSelector(selectProduct);
  const [showToolTip, setshowToolTip] = useState<any>(0);
  const divRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      //@ts-ignore
      if (divRef.current && !divRef.current.contains(event.target)) {
        setshowToolTip(0);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!productState.data) {
    return <></>;
  }

  return (
    <>
      <div className="details_text">
        <p>
          <strong>Design Code: </strong>
          {productState.data.sku}
        </p>
        <p>
          <strong>Metal Purity: </strong>
          {productState.selectedPrice?.purity}
        </p>
        {!!productState.selectedPrice?.size && (
          <p>
            <strong>Size: </strong>
            {productState.selectedPrice?.size}
          </p>
        )}
        {!!(
          productState.selectedPrice?.gold_weight ||
          productState.selectedPrice?.gold2_weight
        ) && (
          <p>
            <strong>Gold Weight: </strong>
            <span className={styles.text_d_r}>
              <>
                {!!productState.selectedPrice?.gold_weight && (
                  <>
                    {productState.selectedPrice.gold_weight} g (
                    {productState.selectedPrice.gold_purity_display_name})
                  </>
                )}
                {!!productState.selectedPrice?.gold2_weight && (
                  <>
                    , {productState.selectedPrice.gold2_weight} g (
                    {productState.selectedPrice.gold2_purity_display_name})
                  </>
                )}
              </>
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(1)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 1 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
                ref={divRef}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.diamond_shape && (
          <p>
            <strong>Diamond Quality: </strong>
            {productState.selectedPrice?.diamond_shape}
          </p>
        )}
        {!!productState.selectedPrice?.diamond_weight && (
          <p>
            <strong>Diamond Weight: </strong>
            <span className={styles.text_d_r}>
              {" "}
              {productState.selectedPrice?.diamond_weight} carat
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(2)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 2 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.platinum_weight && (
          <p>
            <strong>Platinum Weight: </strong>
            <span className={styles.text_d_r}>
              {productState.selectedPrice?.platinum_weight} g
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(3)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 3 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.silver_weight && (
          <p>
            <strong>Silver Weight: </strong>
            {productState.selectedPrice?.silver_weight} g
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(4)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 4 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.titanium_weight && (
          <p>
            <strong>Titanium Weight: </strong>
            <span className={styles.text_d_r}>
              {productState.selectedPrice?.titanium_weight} g
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(5)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 5 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.stone_weight && (
          <p>
            <strong>Stone Weight: </strong>
            <span className={styles.text_d_r}>
              {productState.selectedPrice?.stone_weight} g
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(8)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 8 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.polki_weight && (
          <p>
            <strong>Polki Weight: </strong>
            <span className={styles.text_d_r}>
              {productState.selectedPrice?.polki_weight} g
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(6)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 6 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.kundan_weight && (
          <p>
            <strong>Kundan Weight: </strong>
            <span className={styles.text_d_r}>
              {productState.selectedPrice?.kundan_weight} g
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(7)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 7 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>{" "}
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>{" "}
              </div>
            </div>
          </p>
        )}
        {!!productState.selectedPrice?.no_of_diamond && (
          <p>
            <strong>No. of Diamond: </strong>
            {productState.selectedPrice?.no_of_diamond}
          </p>
        )}
        {!!productState.selectedPrice?.no_of_stone && (
          <p>
            <strong>No. of Stone: </strong>
            {productState.selectedPrice?.no_of_stone}
          </p>
        )}
        {/* {!!productState.selectedPrice?.gross_weight && (
          <p>
            <strong>Gross Weight: </strong>
            <span className={styles.text_d_r}>
              {productState.selectedPrice?.gross_weight} g
            </span>
            <div className={styles.icon_tooltip}>
              <div
                className={`${styles.icon_tooltip_icon} ${styles.mobile_arrow}`}
                onClick={() => setshowToolTip(4)}
              >
                <i className="bi bi-info-circle-fill"></i>
              </div>
              {showToolTip === 4 && (
                <div
                  className={`${styles.tooltip_container} ${styles.mobile_view_tool}`}
                  ref={divRef}
                >
                  <div className={styles.tooltip_container_main}>
                    <Tooltip />
                  </div>
                </div>
              )}
              <div
                className={`${styles.tooltip_container} ${styles.desktop_view_tool}`}
              >
                <div className={styles.tooltip_container_main}>
                  <Tooltip />
                </div>
              </div>
            </div>
          </p>
        )} */}
        {!!productState.data.pieces && (
          <p>
            <strong>Pieces: </strong>
            {productState.data.pieces}
          </p>
        )}
        {!!productState.selectedPrice?.item_length && (
          <p>
            <strong>Item Length: </strong>
            {productState.selectedPrice?.item_length}
          </p>
        )}
        {!!productState.selectedPrice?.item_width && (
          <p>
            <strong>Item Width: </strong>
            {productState.selectedPrice?.item_width}
          </p>
        )}
      </div>
    </>
  );
};

export default ProductDetailsDetailTab;
